import React, { useEffect, useState } from "react";
import { FaRocket } from "react-icons/fa";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import { CircularProgress } from "@mui/material";
import { motion } from "framer-motion";

const AuthPage = () => {
  const [authorized, setAuthorized] = useState(false);
  const [loading, setLoading] = useState(false);
  const [authFailed, setAuthFailed] = useState(false);

  useEffect(() => {
    const t = window.TrelloPowerUp.iframe({
      appKey: "035539076201571631d2a69fa82de83d",
      appName: "Board2Export by Ezy PowerUps",
    });

    const checkAuthorization = async () => {
      try {
        const isAccepted = await t.getRestApi().authorize({
          name: "Board2Export by Ezy PowerUps",
          interactive: false,
          scope: "read,write,account",
          expiration: "never",
        });

        if (isAccepted) {
          setAuthorized(true);
        } else {
          setAuthorized(false);
        }
      } catch (error) {
        //console.error("Erro durante a verificação de autorização:", error);
        setAuthFailed(true);
      }
    };

    checkAuthorization();
  }, []);

  const authorize = async () => {
    if (authorized || loading) return;

    setLoading(true);
    setAuthFailed(false);
    try {
      const t = window.TrelloPowerUp.iframe();

      const isAccepted = await t.getRestApi().authorize({
        name: "Board2Export by Ezy PowerUps",
        interactive: true,
        scope: "read,write,account",
        expiration: "never",
      });

      if (!isAccepted?.includes("rejected")) {
        setAuthorized(true);
        window.close();
      } else {
        setAuthFailed(true);
      }
    } catch (error) {
      console.error("Erro durante a autorização:", error);
      setAuthFailed(true);
    } finally {
      setLoading(false);
    }
  };

  const handleExploreClick = () => {
    const t = window.TrelloPowerUp.iframe();

    t.modal({
      url: "/instructions",
      fullscreen: true,
      title: "Your Board2Export",
    });
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      bgcolor="#f4f7f9"
      p={3}
      pt={0}
    >
      {!authorized ? (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          style={{ textAlign: "center", maxWidth: 500 }}
        >
          <img
            src="https://zealous-field-00cc03a10.5.azurestaticapps.net/img/logo.svg"
            alt="logo"
            width="75px"
          />
          <Typography variant="h5" fontWeight={300} mt={2}>
            Add{" "}
            <span
              style={{
                textDecoration: "underline",
                textDecorationColor: "#008c23",
                fontWeight: 500,
              }}
            >
              Board
              <span style={{ textDecoration: "underline", color: "#008c23" }}>
                2
              </span>
              Export
            </span>{" "}
            to your Trello Board
          </Typography>

          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            mt={2}
            mb={3}
          >
            <FaRocket
              size={30}
              style={{ marginRight: "10px", color: "#008c23" }}
            />
            <Typography variant="h6">Board2Export for your boards.</Typography>
          </Box>

          <Button
            variant="contained"
            color="success"
            onClick={authorize}
            sx={{ fontWeight: 700, width: "100%", mb: authFailed ? 1 : 2 }}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Authorize"
            )}
          </Button>

          {authFailed && (
            <Typography color="error">
              Authorization was declined. Please try again.
            </Typography>
          )}

          <Typography variant="body2" color="textSecondary" fontWeight={300}>
            Any questions? Email us at{" "}
            <Link href="mailto:support.board2export@smartezy.com.br?subject=Support to:Board2Export">
              support.board2export@smartezy.com.br
            </Link>
          </Typography>
        </motion.div>
      ) : (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          style={{ textAlign: "center", maxWidth: 500 }}
        >
          <img
            src="https://zealous-field-00cc03a10.5.azurestaticapps.net/img/logo.svg"
            alt="logo"
            width="75px"
          />
          <Typography variant="h5" fontWeight={300} mt={2}>
            <span
              style={{
                textDecoration: "underline",
                textDecorationColor: "#008c23",
                fontWeight: 500,
              }}
            >
              Board
              <span style={{ textDecoration: "underline", color: "#008c23" }}>
                2
              </span>
              Export
            </span>{" "}
            successfully added to your Trello Board
          </Typography>

          <Box display="flex" alignItems="center" my={2}>
            <FaRocket
              size={30}
              style={{ marginRight: "10px", color: "#008c23" }}
            />
            <Typography variant="h6">
              Take advantage of Board2Export unique features.
            </Typography>
          </Box>

          <motion.div
            style={{
              width: 200,
              height: 50,
              display: "inline-block",
              borderRadius: 4,
              overflow: "hidden",
              background:
                "linear-gradient(90deg, #1b5e20, #00796b, #1b5e20, #008c23)",
              backgroundSize: "400%",
            }}
            initial={{ backgroundPosition: "0% 50%" }}
            animate={{ backgroundPosition: "100% 50%" }}
            transition={{
              duration: 4,
              repeat: Infinity,
              repeatType: "mirror",
              ease: "linear",
            }}
          >
            <Button
              variant="contained"
              onClick={handleExploreClick}
              sx={{
                fontWeight: 900,
                width: "100%",
                height: "100%",
                fontSize: 20,
                background: "transparent",
                color: "#fff",
                border: "none",
                boxShadow: "none",
                textTransform: "none",
              }}
            >
              Explore
            </Button>
          </motion.div>
        </motion.div>
      )}
    </Box>
  );
};

export default AuthPage;
